import {
  Button,
  makeStyles,
  Typography,
  Backdrop,
  useTheme
} from "@material-ui/core";

import { MdErrorOutline } from "react-icons/md";

import ErrorPage from "../../components/ErrorPage";

import { coreRoutesConstants } from "modules/core/routes/routesConstants";

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.palette.secondary.main
  },

  button: {
    display: "flex",
    justifyContent: "center",
    marginTop: 30
  }
}));

const Error404 = () => {
  const theme = useTheme();

  const classes = useStyles();

  return (
    <Backdrop open style={{ zIndex: theme.zIndex.modal, color: "#fff" }}>
      <div style={{ width: "100vw", height: "100vh" }}>
        <ErrorPage
          icon={<MdErrorOutline className={classes.icon} size={64} />}
          title="404 Error"
          content={
            <>
              <Typography variant="body1" align="center" gutterBottom>
                This page could not be found or the link is no longer available
              </Typography>

              <div className={classes.button}>
                <Button
                  variant="contained"
                  color="primary"
                  component="a"
                  href={coreRoutesConstants.dashboard.href("all")}
                >
                  Go to dashboard
                </Button>
              </div>
            </>
          }
        />
      </div>
    </Backdrop>
  );
};

export default Error404;
